import { SessionCheck, SessionError } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import { KC_BASE_URL } from '../../lib/runtimeEnv.js';
import { brandAsset } from '../../lib/brandAssets.js';

/**
 * The clinic panel's words and logo for the kit's session screens.
 *
 * The card itself — layout, motion, the manual-link timer, and continuing
 * across the `App` → `RoutedApp` remount — is `SessionCheck` / `SessionError`
 * in `@parsina/framework` (packages/DESIGN.md §"Session check"), shared by
 * every Parsina panel. Nothing visual belongs here; change it in the kit.
 */

export function BootLoading({ onManualSignIn, testId = 'auth-redirect' }) {
  const { t } = useTranslation();
  return (
    <SessionCheck
      testId={testId}
      logo={brandAsset('logoWhite')}
      brandName={t('common.brand.name')}
      panelName={t('nav.title.clinicPanel')}
      title={t('auth.redirect.title')}
      subtitle={t('auth.redirect.subtitle')}
      stuckLabel={t('auth.redirect.stuck')}
      manualLabel={t('auth.redirect.manualLink')}
      onManualSignIn={onManualSignIn}
    />
  );
}

/**
 * `tone="danger"` — the sign-in service failed; `tone="warning"` — the clinic
 * backend failed after sign-in succeeded.
 */
export function BootError({
  tone = 'danger', title, body, detail, actionLabel, onAction, testId = 'auth-error', stateTestId,
}) {
  const { t } = useTranslation();
  return (
    <SessionError
      testId={testId}
      stateTestId={stateTestId}
      tone={tone}
      logo={brandAsset('logo')}
      brandName={t('common.brand.name')}
      title={title}
      body={body}
      detail={detail}
      actionLabel={actionLabel || t('common.actions.retry')}
      onAction={onAction}
      host={KC_BASE_URL.replace(/^https?:\/\//, '')}
    />
  );
}
